import VJsoneditor from "v-jsoneditor";
import "./LayoutWizardConfig.scss";
import { getTokenHeader } from "@/helpers/commonHelper";
import * as layoutWizardHelper from "@/helpers/layoutWizardHelper";
import axios from "axios";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);
import { confirmWarningConfig } from "@/configuration/confirmConfigurations";
import LayoutWizardSeasonDialog from "@/components/LayoutWizard/LayoutWizardSeasonDialog/LayoutWizardSeasonDialog.vue";
import LayoutWizardMetadataGroup from "@/components/LayoutWizard/LayoutWizardMetadataGroup/LayoutWizardMetadataGroup.vue";

export default {
  name: "LayoutWizardConfig",
  components: {
    VJsoneditor,
    LayoutWizardMetadataGroup,
    LayoutWizardSeasonDialog
  },
  data() {
    return {
      config: {
        url: "",
        print_xml_export: 0,
        editor_sp_allow_edit: false,
        editor_sp_allow_delete: false,
        sp_data_fields: {},
        sp_features: "",
        sp_types: "",
        export_config: ""
      },
      metadataGroups: [],
      metaItems: [],
      metaItemsGroup: {},
      metaItemDialog: false,
      defaultgroupItem: {
        title: "",
        key: "",
        principal_id: "",
        admin_group: false,
        sort_key: 0,
        fields: {},
        created: "",
        changed: ""
      },
      code_options: { mode: "code" },
      mainPeacock: "#00636C",
      mainRed: "#c55c52",
      isRequired: [v => !!v || "Feld bitte ausfüllen"],

      snackbar: false,
      snackbarColor: "#000",
      snackbarText: "asdf"
    };
  },
  created() {
    if (!this.isAdmin) {
      this.$router.push("/");
    }
  },
  mounted() {
    this.loadConfig();
    this.loadMetadataGroups();
  },
  computed: {
    currentPrincipal() {
      return this.$store.state.selectedPrincipal.id;
    },
    isAdmin() {
      return this.$store.state.currentUser?.scopes.includes("role:admin");
    }
  },
  methods: {
    ...layoutWizardHelper,
    jsonEditorError(value) {
      console.error("jsonEditorError:", value);
    },
    async createConfig() {
      this.config._id = this.currentPrincipal;
      if (!this.config.url) {
        this.snackMessage(
          "Config nicht erstellt. Bitte Basis-URL angeben!",
          this.mainRed
        );
        return;
      }
      try {
        const headers = getTokenHeader(),
          res = await axios.post(
            `${env.assistent_api_client_url}configs`,
            this.config,
            { headers }
          );
        this.config = res.data;
        if (res.status === 200) {
          this.snackMessage("Erfolgreich gespeichert!");
        }
      } catch (err) {
        this.createError(err);
        this.snackMessage("Fehler! Nicht gespeichert!", this.mainRed);
      }
    },
    async saveConfig() {
      try {
        const headers = getTokenHeader(),
          res = await axios.put(
            `${env.assistent_api_client_url}configs/${this.config._id}`,
            this.config,
            { headers }
          );
        if (res.status === 200) {
          this.snackMessage("Erfolgreich gespeichert!");
        }
      } catch (err) {
        this.createError(err);
        this.snackMessage("Fehler! Nicht gespeichert!", this.mainRed);
      }
    },
    async deleteConfig() {
      const principal = this.$store.state.selectedPrincipal;
      this.$confirm(
        `Sind Sie sicher, dass Sie <br>
        die Anzeigenassistent-Config <b>${principal.name}</b> löschen wollen?`,
        { ...confirmWarningConfig, title: `${principal.name} Config löschen?` }
      ).then(async resp => {
        if (resp) {
          try {
            const headers = getTokenHeader(),
              res = await axios.delete(
                `${env.assistent_api_client_url}configs/${this.config._id}`,
                { headers }
              );
            delete this.config._id;
            if (res.status === 200) {
              this.snackMessage("Erfolgreich gelöscht!");
            }
          } catch (err) {
            this.createError(err);
            this.snackMessage("Fehler! Nicht gelöscht!", this.mainRed);
          }
        }
      });
    }
  }
};
